import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {CustomerUserMembershipCRUDComponent} from '../../../components/customer-user-membership-crud/customer-user-membership-crud.component';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';

@Component({
    selector: 'app-ga-customer-user-memberships-page',
    templateUrl: './customer-user-memberships-page.component.html',
    imports: [PrimeNgImportsModule, CustomerUserMembershipCRUDComponent]
})
export class GCustomerUserMembershipsPage extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
